(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

/* eslint-disable no-undef */

/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import OutsideClick from "../OutsideClick";
import DownloadButtonItem from "./DownloadButtonItem";
import { ChevronDown } from "../../icons/ChevronDown";
import styles from "./DownloadButton.module.css";

const DownloadButton = _ref => {
  let {
    selectOptions,
    label,
    disabled,
    loading,
    onClick,
    className,
    isRtl
  } = _ref;
  const wrapper = cx([styles.wrapper], className, {
    [styles.loading]: loading
  });
  const [visible, setVisible] = useState(false);
  const listClassName = cx([styles.list], {
    [styles.show]: visible,
    [styles.rtl]: isRtl
  });
  const handleClick = useCallback(() => {
    if (!disabled) {
      setVisible(!visible);
    }
  }, [disabled, visible]);
  const handleOutsideClick = useCallback(() => {
    setVisible(false);
  }, []);
  return /*#__PURE__*/React.createElement(OutsideClick, {
    onClick: handleOutsideClick
  }, /*#__PURE__*/React.createElement("div", {
    className: wrapper,
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.label
  }, label), /*#__PURE__*/React.createElement("ul", {
    className: listClassName
  }, selectOptions.map(option => /*#__PURE__*/React.createElement(DownloadButtonItem, {
    option: option,
    key: option.value,
    handleItemClick: onClick
  }))), /*#__PURE__*/React.createElement(ChevronDown, {
    color: "#333741",
    className: cx(styles.icon, {
      [styles.rtl]: isRtl
    })
  })));
};

__signature__(DownloadButton, "useState{[visible, setVisible](false)}\nuseCallback{handleClick}\nuseCallback{handleOutsideClick}");

DownloadButton.defaultProps = {
  loading: false,
  disabled: false,
  isRtl: false,
  className: null
};
DownloadButton.propTypes = {
  selectOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  }).isRequired).isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  isRtl: PropTypes.bool
};

const _default = /*#__PURE__*/React.memo(DownloadButton);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(DownloadButton, "DownloadButton", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/DownloadButton/DownloadButton.jsx");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/DownloadButton/DownloadButton.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();